import { Button, Layout, Menu, Modal, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router';
import ActionHeader from '../../../components/actionHeader';
import Page from '../../../components/page';
import {
  fetchMachineById,
  selectIsFetchingMachine,
  selectMachine,
} from '../../../slices/machines';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store';
import { StyledContent, StyledMenu } from './styles';
import { deleteMachine } from '../../../utils/httpRequest';
import { useTranslation } from 'react-i18next';

const MachineDetailsContainer = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id = '' } = useParams();

  const machine = useSelector(selectMachine);
  const isFetchingMachine = useSelector(selectIsFetchingMachine);

  const { pathname } = location;

  const selectedKeys = pathname.split('/').slice(4);

  const [defaultOpenKeys, setDefaultOpenKeys] = useState<string[]>([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const menus = [
    { key: '', label: t('details') },
    { key: 'solutionGrid', label: t('solution_grid') },
    { key: 'issue', label: t('issue') },
    { key: 'cause', label: t('cause') },
    { key: 'routine', label: t('routine') },
    { key: 'resourceLibrary', label: t('resource_library') },
  ];

  const handleDelete = async () => {
    try {
      setShowDeleteModal(false);
      setLoading(true);
      await deleteMachine(id);
      navigate('/knowledge/machine');
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(fetchMachineById(id));
  }, []);

  return (
    <Page
      backgroundColor="#fff"
      gap={0}
      header={
        <ActionHeader
          title={machine?.name}
          showBack
          onBack={() => navigate(-1)}
          endSlot={
            <>
              <Button
                type="primary"
                danger
                ghost
                onClick={() => setShowDeleteModal(true)}
              >
                {t('delete')}
              </Button>
              <Button type="primary" ghost onClick={() => navigate('edit')}>
                {t('edit')}
              </Button>
            </>
          }
        />
      }
    >
      <Spin spinning={isFetchingMachine || loading} fullscreen>
        {' '}
        {loading && t('deleting')}
      </Spin>
      <Layout style={{ height: '100%' }}>
        <Layout.Sider style={{ backgroundColor: '#f7f7f7' }} width={144}>
          <StyledMenu
            selectedKeys={selectedKeys[0] ? selectedKeys : ['']}
            defaultOpenKeys={defaultOpenKeys}
            theme="light"
            items={menus}
            onClick={({ key, keyPath }) => {
              navigate(key, { replace: true });
              setDefaultOpenKeys(keyPath);
            }}
          />
        </Layout.Sider>
        <StyledContent>
          <Outlet />
        </StyledContent>
        <Modal
          title={t('delete_machine', { name: machine?.name })}
          closable={{ 'aria-label': 'Custom Close Button' }}
          open={showDeleteModal}
          onOk={handleDelete}
          onCancel={() => setShowDeleteModal(false)}
        >
          <p>{t('confirm_delete_machine', { name: machine?.name })}</p>
        </Modal>
      </Layout>
    </Page>
  );
};

export default MachineDetailsContainer;
